import 'yet-another-react-lightbox/styles.css'

import { ChevronDownIcon, ChevronUpIcon } from '@calizahq/react-components-v2'
import React, { FC, useState } from 'react'
import Lightbox from 'yet-another-react-lightbox'

import { useToggle } from '@/hooks'
import { Attachment } from '@/types/Attachment'

type Props = {
  attachments: Attachment[]
}
export const Attachments: FC<Props> = ({ attachments }) => {
  const { isShown, toggle } = useToggle()
  const [photoIndex, setPhotoIndex] = useState(0)
  const [isOpen, setIsOpen] = useState(false)

  const images = attachments.filter((attachment) => attachment.contentType.includes('image'))
  const files = attachments.filter((attachment) => !attachment.contentType.includes('image'))

  const showImage = (index: number) => {
    setPhotoIndex(index)
    setIsOpen(true)
  }

  const getFileName = (fileName: string = '') => {
    const paths = fileName.split('/')
    return paths.pop()
  }

  return (
    <>
      {attachments && attachments.length > 0 && (
        <div>
          <div className="mt-2 flex items-center">
            {isShown ? (
              <ChevronUpIcon className="mr-2 icon-primary" onClick={toggle} width={14} />
            ) : (
              <ChevronDownIcon className="mr-2 icon-primary" onClick={toggle} width={14} />
            )}
            <p className="cursor-pointer text-p-xs text-tertiary" onClick={toggle} role={'presentation'}>
              Attachments
            </p>
          </div>
          {isShown && (
            <div className="mt-2 flex w-full flex-col">
              {files.length > 0 && (
                <div className="flex flex-wrap">
                  {files.map((file) => (
                    <a
                      className="mb-1 mr-2 rounded-lg bg-white px-2 py-1 text-p-xs underline"
                      href={`/${file.path}`}
                      key={file.id}
                      rel="noreferrer"
                      target="_blank"
                    >
                      {getFileName(file.filename)}
                    </a>
                  ))}
                </div>
              )}
              {images.length > 0 && (
                <div className="grid grid-cols-3 place-items-stretch gap-3 md:grid-cols-4">
                  {images.map((file, i) => (
                    <img
                      alt={file.filename}
                      aria-hidden="true"
                      className="h-30 w-30 overflow-hidden rounded-lg md:w-48"
                      key={i}
                      onClick={() => showImage(i)}
                      src={`/${file.path}`}
                    />
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      )}
      <Lightbox
        close={() => setIsOpen(false)}
        index={photoIndex}
        open={isOpen}
        slides={images.map((img) => ({ src: `/${img.path}` }))}
      />
    </>
  )
}
